import { IReport } from 'src/models/report';
import { AsyncState, IAction, IAsyncState } from '../action';
import { actionTypes } from './actions';

// #region -------------- State -------------------------------------------------------------------

export interface IReportManagerState {
  reports: IAsyncState<IReport[]>;
  reportRemoveStatus: IAsyncState<boolean>;
  reportDownloadStatus: IAsyncState<boolean>;
}

const initialState: IReportManagerState = {
  reports: new AsyncState(),
  reportRemoveStatus: new AsyncState(),
  reportDownloadStatus: new AsyncState(),
};

// #endregion

// #region -------------- Reducer -------------------------------------------------------------------

export function reportManagerReducer(state: IReportManagerState = initialState, action: IAction): IReportManagerState {
  switch (action.type) {
    case actionTypes.requestReportsList:
      return {
        ...state,
        reports: {
          ...state.reports,
          isFetching: true,
          timestamp: new Date(),
        },
      };
    case actionTypes.receiveReportsList:
      return {
        ...state,
        reports: {
          ...state.reports,
          ...action.payload,
        },
      };
    case actionTypes.downloadReport:
      return {
        ...state,
        reportDownloadStatus: {
          ...state.reportDownloadStatus,
          isFetching: true,
          timestamp: new Date(),
        },
      };
    case actionTypes.reportDownloadStatus:
      return {
        ...state,
        reportDownloadStatus: {
          ...state.reportDownloadStatus,
          ...action.payload,
        },
      };
    case actionTypes.removeReport:
      return {
        ...state,
        reportRemoveStatus: {
          ...state.reportRemoveStatus,
          isFetching: true,
          timestamp: new Date(),
        },
      };
    case actionTypes.reportRemoveStatus:
      return {
        ...state,
        reportRemoveStatus: {
          ...state.reportRemoveStatus,
          ...action.payload,
        },
      };
    case actionTypes.removeMessage:
      return {
        ...state,
        reportRemoveStatus: {
          ...state.reportRemoveStatus,
          data: null,
        },
      };
    default:
      return state;
  }
}

// #endregion
